export default __webpack_public_path__ + "static/media/HUN.8bdd9494.svg";